import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const DashboardIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M6.599 25.401c5.185 5.185 13.621 5.185 18.805 0 3.761-3.761 4.781-9.23 3.085-13.931l2.019-2.221c2.755 5.92 1.693 13.177-3.192 18.063-6.249 6.248-16.38 6.248-22.628 0s-6.249-16.38 0-22.629c4.885-4.885 12.142-5.947 18.062-3.192l-2.221 2.019c-4.7-1.697-10.169-0.677-13.93 3.085-5.185 5.185-5.185 13.621 0 18.806zM27.83 5.865l-8.053 9.159c0.384 1.366 0.041 2.894-1.034 3.969-1.584 1.583-4.152 1.583-5.735 0s-1.584-4.152 0-5.735c1.075-1.075 2.602-1.418 3.968-1.034l9.131-8.015c0 0 0.203-0.192 0.277-0.248 0.439-0.333 1.088-0.242 1.494 0.164 0.421 0.421 0.487 1.095 0.127 1.545-0.041 0.051-0.175 0.195-0.175 0.195z"
  }));
};
export default /*#__PURE__*/memo(DashboardIcon);